import React, { useEffect, useState } from "react";
import Invoice from "../../../../images/Invoice.png";
import { getPatientByID } from "../../../../Utils/localStore";

const InvoiceView = ({ onClose, details }) => {
  const [user, setUser] = useState(null)
  const getUser = async () => {
    const response = await getPatientByID(details.userLocalId)
      .then((resp) => {
        setUser({ ...resp[0] })
      })
  }
  useEffect(() => {
    getUser()
  }, [])
  return (
    <section className=" bg-black bg-opacity-25 w-[100%] h-[100%] font-euclid-circular-a fixed top-0 right-0 flex-col justify-start items-start" onClick={() => onClose()}>
      <div
        className="cursor-pointer relative w-[35px] h-[2.3rem] top-5 left-[84%] z-50 rounded-full bg-white flex items-center p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="24"
          viewBox="0 0 18 24"
          fill="none"
        >
          <path
            d="M2.25 23.5L0.5 21.225L7.5 12.125L0.5 3.025L2.25 0.75L9.25 9.85L16.25 0.75L18 3.025L11 12.125L18 21.225L16.25 23.5L9.25 14.4L2.25 23.5Z"
            fill="black"
          />
        </svg>
      </div>

      <div className=" font-euclid-circular-a bg-white w-[660px] h-[585px] fixed top-[11%] right-[20%] shadow flex-col justify-start items-start p-2 overflow-auto">
        {/* <img src={Invoice} alt="Invoice view" />
         */}

        <section class="bg-white text-gray-900">
          <div class="max-w-4xl mx-auto p-8">
            <div class=" mb-8 text-left">
              <h1 class="text-4xl font-bold text-primary">Pharmanager</h1>
            </div>

            <div class="flex justify-between items-center mb-8">
              <div>
                <h2 class="text-2xl font-bold text-primary">INVOICE</h2>
                <p class="text-sm text-primary">INVOICE NO: PM-{details?.localID}-{details?.userLocalId}</p>
              </div>
              <div class="text-right">
                <p class="text-sm"><span class="font-bold">ISSUE DATE:</span> {details?.date.split('at')[0]}</p>
                <p class="text-sm"><span class="font-bold">DUE DATE:</span> {details?.dueDate}</p>
              </div>
            </div>

            <div class="flex justify-between mb-8">
              <div>
                <h3 class="text-lg font-bold text-primary">DOCTORS DETAILS:</h3>
                <p>Dr. John Doe</p>
                <p>Resident Doctor In Charge</p>
                <p>MD 25320</p>
              </div>
              <div class="text-right">
                <h3 class="text-lg font-bold text-primary">PATIENTS DETAILS:</h3>
                <p >{user?.patientName}</p>
                <p>{user?.address}</p>
                <p>{user?.contactDetails}</p>
              </div>
            </div>

            <table class="min-w-full bg-white border border-primary">
              <thead>
                <tr>
                  <th class="py-2 px-4 border-2 border-  border-primary">S/N</th>
                  <th colSpan={3} class="py-2 px-4 border-2  border-primary">Item Description</th>
                  <th class="py-2 px-4 border-2  border-primary">Rate (₦)</th>
                  <th class="py-2 px-4 border-2  border-primary">Amount (₦)</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="border-2 border-primary">
                <tr className="border-2 border-primary">
                  <td class="py-2 px-4 border-2  border-primary text-center">1</td>
                  <td class="py-2 px-4 border-2  border-primary" colSpan={3}>{details.description}</td>
                  <td class="py-2 px-4 border-2  border-primary text-right">{details?.amount}</td>
                  <td class="py-2 px-4 border-2  border-primary text-right">{details?.amount}</td>
                </tr>
              </tbody>
            </table>

            <div class="mt-16 flex justify-end">
              <div class="text-center">
                <p class="font-bold">DOCTORS SIGNATURE</p>
                <p class="mt-4">
                  signature
                  {/* <img src="signature.png" alt="Signature" class="inline-block"></p> */}
                </p>
                <p class="font-bold">John Doe</p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </section>
  );
};

export default InvoiceView;
